const CompanyData = [
  {
    name: "Apocalypse Girl",
    location: "Carolina",
    phone: "(919) 535-3035",
    opentime: "Mon-Sun: 12:00pm - 8:00pm",
    facebook: "https://www.facebook.com/profile.php?id=100089770508767",
    instagram: "https://www.instagram.com",
  },
];

export default CompanyData;
